import selectionUtils from 'utils/selectionUtils';
import styleCommand from 'commands/styleCommand';

function FontWeightCommand() {
    styleCommand.call(this, 'span', 'font-weight');
}

FontWeightCommand.prototype = Object.create(styleCommand.prototype);

FontWeightCommand.prototype.exec = function (editor, value) {
    styleCommand.prototype.exec.call(this, editor, value);
    selectionUtils.getSelectedLists(editor).forEach(listElement => this.applyOnElement(value, listElement));
};

FontWeightCommand.prototype.refresh = function (editor, elementPath) {
    styleCommand.prototype.refresh.call(this, editor, elementPath);

    var val = this.state;
    if (this.state === 'normal') {
        val = '400';
    } else if (this.state === 'bold') {
        val = '700';
    }

    this.setState(val);
};


FontWeightCommand.prototype.applyOnElement = function (value, element) {
    element.setStyle('fontWeight', value);
};

export default FontWeightCommand;
